import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from 'react';
import { Box, TableCell, TableRow } from '@applyboard/ui-components';
import ScoreResult from "./ScoreResult";
var CriteriaSubScores = function CriteriaSubScores(_ref) {
  var subScores = _ref.subScores,
    _ref$baseKey = _ref.baseKey,
    baseKey = _ref$baseKey === void 0 ? '' : _ref$baseKey;
  if (!subScores || _typeof(subScores) !== 'object' || Object.keys(subScores).length <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(subScores).filter(function (e) {
    return e !== baseKey;
  }).map(function (key) {
    var result = subScores === null || subScores === void 0 ? void 0 : subScores[key];

    // only shows result on english detail table if it's false.
    var requirementMet = (result === null || result === void 0 ? void 0 : result.requirementMet) === false ? result.requirementMet : undefined;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box, {
        pl: 1,
        style: {
          textTransform: 'capitalize'
        }
      }, key)), /*#__PURE__*/React.createElement(ScoreResult, {
        applicantHas: result === null || result === void 0 ? void 0 : result.applicantHas,
        requirementMet: requirementMet,
        requires: result === null || result === void 0 ? void 0 : result.requires
      }))
    );
  }));
};
export default CriteriaSubScores;